import api from "@/utils/api";

const payloadToFormData = (payload) => {
  const formData = new FormData();
  for (const key in payload) {
    formData.append(key, payload[key]);
  }
  return formData;
};

const state = {
  organizations: [],
};

const mutations = {
  setOrganizations(state, data) {
    state.organizations = data;
  },
};

const actions = {
  async getOrganizations({ commit }) {
    const { data } = await api.get("/enterprise/organizations");
    commit("setOrganizations", data);
  },
  async createOrganization({ dispatch }, payload) {
    const formData = payloadToFormData(payload);

    await api.post("/enterprise/organizations", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    dispatch("getOrganizations");
  },
  async updateOrganization({ dispatch }, { id, payload }) {
    const formData = payloadToFormData(payload);

    await api.put(`/enterprise/organizations/${id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    dispatch("getOrganizations");
  },
  async updateOrgMember({ dispatch }, { id, payload }) {
    const formData = payloadToFormData(payload);

    await api.post(`/enterprise/organizations/${id}/member`, formData);
    dispatch("getOrganizations");
  },
  async deleteOrganization({ dispatch }, id) {
    await api.delete(`/enterprise/organizations/${id}`);
    dispatch("getOrganizations");
  },
  async generateSAMLMetadata() {
    const { data } = await api.get(`/enterprise/saml/metadata`);
    const blob = new Blob([data], { type: "application/xml" });
    // Create a new URL for the blob object
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "downloaded_file.xml";
    document.body.appendChild(a);
    a.click();

    // Cleanup
    a.remove();
    window.URL.revokeObjectURL(url);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
